/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetTypeRouter_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTypeRouter_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "withWidgetData_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/__generated__/WidgetTypeRouter_surveys.graphql.js